<template>
    <div v-if="showPreloader" class="preloader">
        <svg class="preloader__svg">
            <use xlink:href="#svg-preloader"></use>
        </svg>
    </div>
</template>

<script>
    export default {
        name: 'preloader',
        data() {
            return {
                showPreloader: false
            }
        },
        methods: {
            add() {
                this.showPreloader = true;
            },
            remove() {
                setTimeout(() => this.showPreloader = false,200);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .preloader{
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255, 255, 255, .8);
        &__svg{
            fill: var(--border-colour-primary);
            width: 30px;
            height: 30px;
            animation: preload 2s linear infinite;
            @keyframes preload {
                from{
                    transform: rotate(0deg);
                }
                to{
                    transform: rotate(360deg);
                }
            }
        }
    }
</style>